const ROUTES = {
  HOME: '/',
  MY_POLICY: '/my-policy',
  CLAIMS: 'claims',
  PEME: '/peme',
  HELP_AND_SUPPORT: '/help-n-support',
  HEALTH_INSIGHTS: '/health-insights',
  SETTINGS: '/settings',
  LOGIN: '/login',
  MIS_REPORTS: '/mis-reports',
  EMPLOYEE_SEARCH: '/employee-search',
  CLAIMS_AND_PREAUTHS: '/claims',
  DOWNLOAD_ECARD: '/download-ecard',
  UTILISATION_TRENS: '/utilisation-trends',
  SPECIAL_MIS: '/special-mis',
};

export default ROUTES;
